import { render, staticRenderFns } from "./archaeology_handset.vue?vue&type=template&id=4e328810&scoped=true"
import script from "./archaeology_handset.vue?vue&type=script&lang=js"
export * from "./archaeology_handset.vue?vue&type=script&lang=js"
import style0 from "./archaeology_handset.vue?vue&type=style&index=0&id=4e328810&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e328810",
  null
  
)

export default component.exports